import * as React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { Stack, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/system";

export default function Testimonials() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery("(max-width:768px)");

  return (
    <Box
      id="testimonials"
      sx={{
        width: "100%",
      }}
    >
      <Typography
        variant="h1"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize:{xs: "2rem", md: "2.5rem"},
          margin: "2%",         
        }}
      >
        Risk Report
      </Typography>
      <Typography
        variant="body1"
        sx={{
          display: "flex",
          justifyContent: "center",
          fontSize: "1.4rem",
          fontFamily: "sans-serif",
          margin: "0 15% 5% 15%",
          lineHeight: 1.5,
          letterSpacing: 0.2,
          textAlign: "center",
          [theme.breakpoints.down("sm")]: {
            margin: "0 5% 5% 5%",
            fontSize: "1.2rem",
          },
        }}
      >
        Get the most in-depth risk assessment reports. Evaluate 360 degree Risk associated with
        related Parties of your portfolio.

      </Typography>
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pb: { xs: 8, sm: 12 },
        }}
      >
        <Stack spacing={2} useFlexGap>
          <Typography
            component="h1"
            variant="h1"
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              textAlign: "center",
            }}
          ></Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center",
            }}
          >
            <img
              src={require("../img/4.png")}
              alt="Description of the image"
              style={{ width: "50%", height: "auto", maxWidth: "500px" }}
            />
            <Box
              sx={{
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                flex: "1",
                mt: isSmallScreen ? 3 : 0,
              }}
            >
              <Typography
                component="h4"
                variant="h4"
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  [theme.breakpoints.down("sm")]: {
                    flexDirection: "column",
                    textAlign: "center",
                  },
                }}
              >
                {/* An Easy to use, multi-asset portfolio&nbsp; */}
                <Typography
                  component="span"
                  variant="h4"
                  sx={{
                    color:
                      theme.palette.mode === "light"
                        ? "primary.main"
                        : "primary.light",
                  }}
                >
                  {/* Maker */}
                </Typography>
              </Typography>
              <Typography
  variant="body1"
  sx={{
    fontSize: "1rem",
    fontFamily: "sans-serif",
    margin: "5% 15%",
    lineHeight: 1.5,
    letterSpacing: 0.2,
    textAlign: "left",
    [theme.breakpoints.down("sm")]: {
      margin: "5% 5%",
      fontSize: "1.2rem",
    },
  }}
>
  ● <strong>Company Highlights</strong>: News, Business Profile, KYC Details, and Comparables.<br/>
  ● <strong>Company Network</strong>: Promoters, Directors, Executives Network, Ownership Changes.<br/>
  ● <strong>Ownership Distribution</strong>: Shareholding Distribution, Share Capital, Share Transfers.<br/>
  ● <strong>Entity Structures</strong>: Holding Company Subsidiaries, Associates, Related Parties, Joint Ventures.<br/>
  ● <strong>Lending & Borrowing</strong>: Ratings, Borrowings, Loan Details, Suits By Lenders, Prosecutions, Contingent Liability.<br/>
  ● <strong>Company Financials</strong>: Profit & Loss, Balance Sheet, Cash Flow, Key Ratios, Debt Profile.<br/>
  ● <strong>Cases & Defaults</strong>: Court Cases, Statutory Defaults, Cash Diversions, Guarantees, Qualifications.<br/>
  ● <strong>Deals & Transactions</strong>: Private Placements, NCD/CD.<br/>
  ● <strong>Blacklist & Frauds</strong>: Credit Scores, GST Compliances, Blacklists, Utility Checks, Negative News.
</Typography>

            </Box>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
}
